// extracted by mini-css-extract-plugin
module.exports = {"container":"_1DrueXeK2VRTN2FMkq6aLr","title":"_130nbHdPDYj9z4l1MHIO3m","logo":"_1DWlXO36Uof-qnWxjIMCGc","submitButton":"_2js5R_QrnoCXi4ewvPjo0q"};